import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalCashRegisterDialogComponent } from '@shared/dialogs/register-dialog/local-cash-register-dialog.component';

export interface LocalCashRegister {
   isDayRegister?: boolean;
   cashRegisterLocationId?: number;
}

@Injectable({
   providedIn: 'root',
})
export class LocalCashRegisterService {
   constructor(private dialog: MatDialog) {}

   getCashRegister(): LocalCashRegister {
      const register = localStorage.getItem('register');
      return register
         ? JSON.parse(register)
         : {
              isDayRegister: true,
           };
   }

   openRegisterSettings() {
      const dialogRef = this.dialog.open(LocalCashRegisterDialogComponent, {
         width: '420px',
      });

      dialogRef.afterClosed().subscribe((result) => {
         if (result) {
            this.saveCashRegister(result);
         }
      });
   }

   removeCashRegisterLocationId() {
      this.saveCashRegister({
         ...this.getCashRegister(),
         cashRegisterLocationId: undefined,
      });
   }

   saveCashRegister(cashRegister: LocalCashRegister) {
      localStorage.setItem('register', JSON.stringify(cashRegister));
   }
}
